<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Text input</h1>
			</div>
		</div>

    <div id="content">
      <div class="types">
        <h2>Types</h2>

        <h3>Label</h3>
        <div class="right">
          <mt-input name="with-label" placeholder="Enter your details here" label="Field label"/>
        </div>

        <h3>Caption</h3>
        <div class="right">
          <mt-input name="with-caption" placeholder="Enter your details here" label="Field label" caption="Lorem ipsum dolor sit amet, consectetur adipiscing elit."/>
        </div>

      </div>
      <div class="mt--clearfix"></div>
      <div class="style">
        <h2>Style</h2>
        <h3>Colors</h3>
        <div class="left mt--bg--neutrals-light-gray-01 ">
          <img :src="colors" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Text: #485464  opacity: 30%</p>
          <p>Label text: #485464</p>
          <p>Caption text: #718091</p>
          <p>Border: #B2C0D0</p>
        </div>

        <h3>Sizing</h3>
        <div class="left mt--bg--neutrals-light-gray-01 ">
          <img :src="sizing" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Corner radius: 2px</p>
          <p>Width: auto</p>
          <p>Height: 36px</p>
          <p>Border: 1px</p>
          <p>Font size: 14px (Line height: 22px)</p>
          <p>Label font size: 12px (Line height: 20px)</p>
          <p>Caption font size: 11px (Line height: 14px)</p>
          <p>Horizontal padding: 8px</p>
        </div>
        <div class="mt--clearfix"></div>

        <h2>States</h2>
        <div class="left">
          <img :src="statesNormal" />
        </div>
        <div class="right mt-font--body10">
          <p>Border: #B2C0D0</p>
          <p>Text: #485464  opacity 30%</p>
        </div>
        <div class="left">
          <img :src="statesHover" />
        </div>
        <div class="right mt-font--body10">
          <p>Border: #718091</p>
          <p>Text: #485464  opacity 30%</p>
        </div>
        <div class="left">
          <img :src="statesFocus" />
        </div>
        <div class="right mt-font--body10">
          <p>Border: #097DB7</p>
          <p>Text: #485464  opacity 30%</p>
        </div>
        <div class="left">
          <img :src="statesType" />
        </div>
        <div class="right mt-font--body10">
          <p>Border: #097DB7</p>
          <p>Text: #171B20</p>
        </div>
        <div class="left">
          <img :src="statesValid" />
        </div>
        <div class="right mt-font--body10">
            <p>Border: #B2C0D0</p>
            <p>Text: #171B20</p>
        </div>
        <div class="left">
          <img :src="statesInvalid" />
        </div>
        <div class="right mt-font--body10">
          <p>Border: #B2C0D0</p>
          <p>Text: #171B20</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'text-input-page',
  data () {
    return {
      colors: require('@/assets/text-input-style-colors.svg'),
      sizing: require('@/assets/text-input-style-sizing.svg'),
      statesNormal: require('@/assets/text-input-states-normal.svg'),
      statesHover: require('@/assets/text-input-states-hover.svg'),
      statesFocus: require('@/assets/text-input-states-focus.svg'),
      statesType: require('@/assets/text-input-states-type.svg'),
      statesValid: require('@/assets/text-input-states-enter-vaild.svg'),
      statesInvalid: require('@/assets/text-input-states-enter-invalid.svg'),
    }
  },
  methods: {

  },
}
</script>
<style lang="scss" scoped>
p {
  line-height: 1.57;
  margin: 0;
}
h3 { font-size: 16px; }
.types .right {
  width: 30%;
  padding: 2%;
  float: right;
  height: 94px;
  .button-wrap{
    padding-right: 20px;
  }
}
.styles {
  margin: 0 auto;
  width: 78%;
}
.right {
  padding: 2%;
  float: left;
  .button-wrap{
    padding-right: 20px;
  }
}
.left{
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 730px;
  float: left;
  position: relative;
  margin-bottom: 2em;
  &.height427 { height: 427px; }
  &.imgbox {
    display: block;
    img { width: 100%; }
  }
}


</style>



// WEBPACK FOOTER //
// Input.vue?117c01c4